export enum DataView {
  Grid,
  List,
}
